import styled from 'styled-components';

import FlexContainer from 'common/components/atoms/FlexContainer';
import Button_T from 'common/components/atoms/Button';
import Label from 'common/typography/Label/Label';

export const ButtonContainer = styled(FlexContainer)`
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
`;

export const Button = styled(Button_T)`
  margin-left: 10px;
`;

export const TimeFilterRow = styled(FlexContainer)`
  gap: 10px;
`;

export const HintText = styled(Label)`
  color: ${props => props.theme.colors.grey};
  font-size: 12px;
  margin-top: 4px;
`;
